import * as React from "react";
import Box from "@sproutsocial/seeds-react-box";
import type { TypePeekInContentProps } from "../PeekInTypes";

export const PeekInContent: React.FC<TypePeekInContentProps> = ({
  children,
}) => {
  return (
    <Box
      flex="1 1 auto"
      overflow="auto"
      color="text.body"
      data-slot="peek-in-content"
      data-qa-peek-in-content
      data-drawer-content=""
    >
      {children}
    </Box>
  );
};

PeekInContent.displayName = "PeekInContent";
